// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "bs-platform/lib/es6/belt_Array.js";

function Bookmark(Props) {
  var title = Props.title;
  var href = Props.href;
  var tags = Props.tags;
  return React.createElement("div", {
              className: "p-4 lg:width-1/2 flex flex-row space-x-4"
            }, React.createElement("div", {
                  className: "flex flex-col space-y-2"
                }, React.createElement("svg", {
                      className: "h-6 w-6",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: "2"
                        })), React.createElement("svg", {
                      className: "h-6 w-6",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: "2"
                        }))), React.createElement("div", {
                  className: "flex flex-col"
                }, React.createElement("a", {
                      className: "text-blue-500",
                      href: href
                    }, title), React.createElement("a", {
                      className: "text-gray-500",
                      href: href
                    }, href), React.createElement("div", {
                      className: "flex space-x-2 flex-wrap"
                    }, Belt_Array.map(tags, (function (tag) {
                            return React.createElement("a", {
                                        key: tag,
                                        className: "text-yellow-600",
                                        href: "/t:" + tag
                                      }, tag);
                          })))));
}

var make = Bookmark;

export {
  make ,
  
}
/* react Not a pure module */
